export default __webpack_public_path__ + "static/media/profileImg.3064f7fe.png";